var map = {
	"./auth.svg": "644c",
	"./baremetal.svg": "8c94",
	"./bill.svg": "eeec",
	"./k8s.svg": "808e",
	"./lb.svg": "9564",
	"./monitor.svg": "45b3",
	"./report.svg": "ded9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1329";